import React, { Component, Dispatch } from 'react';
import { Log } from 'ng2-logger';
import Translator from '../../../../../core/i18n';
import { Common } from '../../../../../core/common';
import { IOpenEndedProps } from '../../../../../models/components/add-activity-survey-questions';
import { IAction, IAppState } from '../../../../../models/action/core';
import { connect } from 'react-redux';

const T = Translator.create();
const _logger = Log.create('profile-tabpanel');
let _common: Common;

interface IResponseState {
    responseText: string;
    placeHolder: string;
    isEditing: boolean;
    onEditingDisplayOrder: number;
}

export class OpenEnded extends Component<IOpenEndedProps> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.props.deleteQuestion.bind(this);
    }
    state = {
        responseText: '',
        placeHolder: T.t('r_survey_write_answer'),
        isEditing: false,
        onEditingDisplayOrder: -1
    };

    handleDelete = () => {
        this.props.deleteQuestion(this.props.question.displayOrder, false, T.t('r_delete_survey_question'));
    };

    onChange = (e: any) => {
        if (e && e.target) {
            const question = this.props.question;
            question.description = e.target.value;
            this.props.editQuestion(question);
        }
    };

    onEdit = () => {
        const item = document.getElementById('survey_openended_' + this.props.question.displayOrder);
        if (item) {
            item.focus();
        }
    };

    onKeyUp = (e: any) => {
        if (e && (e.keyCode === 27 || e.charCode === 27)) {
            this.cancelEditing();
        }
    };

    onEditing = (displayOrder: number) => {
        if (this.props.question) {
            const input = document.getElementById('editing-input');
            if (input) {
                input.focus();
            }
        }
    };

    cancelEditing = () => {
        this.setState({ isEditing: false, onEditingDisplayOrder: -1 });
    };

    public render() {
        return (
            <React.Fragment>
                <div className="w-85">
                    <div className="form-input form-group">
                        <div className="form-input form-group survey_input_padding">
                            <textarea
                                required={true}
                                onChange={this.onChange}
                                value={this.props.question.description}
                                rows={1}
                                className="scrooled-input"
                                wrap="off"
                            ></textarea>
                            <span className="highlight" />
                            <span className="bar" />
                            {!this.props.question.description && (
                                <label className="label-spacing">{T.t('r_activity_survey_question_name_placeholder')}</label>
                            )}
                        </div>
                    </div>
                    {/* <div className="row" style={{ marginTop: '1em' }}>
                        <div className="col-12">
                            <textarea
                                id="editing-input"
                                onKeyUp={this.onKeyUp}
                                className="survey_input"
                                disabled={true}
                                rows={5}
                                style={{ marginTop: 10, height: 'inherit!important', float: 'left' }}
                            />
                        </div>
                    </div> */}
                </div>
                <div>
                    <div className="btn_container">
                        <span className="move_btn" {...this.props.dragHandleProps}>
                            <i className="material-icons">open_with</i>
                        </span>
                        <span className="delete_btn" onClick={this.handleDelete}>
                            <i className="material-icons">close</i>
                        </span>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IOpenEndedProps): IOpenEndedProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IOpenEndedProps = Object.assign({}, ownProps, {
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId
    });

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return (
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId
    );
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const COpenEnded = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(OpenEnded);

export default COpenEnded;
